import {
    Box,
    Input,
    Text,
    VStack,
} from "@chakra-ui/react";

const HelpTopicHero = ({
    search,
    setSearch,
}) => {
    return (
        <Box
            bg="linear-gradient(135deg,#2453FF,#4F7BFF)"
            borderRadius="24px"
            p={{
                base: 6,
                md: 10,
            }}
            color="white"
            mb={8}
        >
            <VStack
                gap={4}
                align="stretch"
            >
                <Text
                    fontSize={{
                        base: "2xl",
                        md: "4xl",
                    }}
                    fontWeight="700"
                >
                    How can we help you today?
                </Text>

                <Text opacity={0.9}>
                    Search articles and support guides.
                </Text>

                <Input
                    bg="white"
                    color="black"
                    placeholder="Search help topics..."
                    value={search}
                    onChange={(e) =>
                        setSearch(
                            e.target.value
                        )
                    }
                />
            </VStack>
        </Box>
    );
};

export default HelpTopicHero;